export function PageHeader({
	title,
	subtitle,
	actions,
}: {
	title: string
	subtitle?: string
	actions?: React.ReactNode
}) {
	// Sticks to the top of <main>, the only scrolling element in the shell. The
	// negative inline margins let it span main's gutters so rows pass behind it
	// rather than beside it, and it owns the top padding main used to have.
	return (
		<div className="sticky top-0 z-20 -mx-5 mb-5 flex flex-wrap items-start justify-between gap-3 bg-canvas px-5 pb-4 pt-5 lg:-mx-8 lg:px-8 lg:pt-8">
			<div>
				<h1 className="font-display text-2xl font-semibold">{title}</h1>
				{subtitle && <p className="mt-1 text-sm text-ink-soft">{subtitle}</p>}
			</div>
			{actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
		</div>
	)
}

export function Field({ label, children }: { label: string; children: React.ReactNode }) {
	return (
		<div className="min-w-0">
			<dt className="text-xs font-medium text-ink-soft">{label}</dt>
			<dd className="mt-0.5 truncate text-sm">{children ?? <span className="text-ink-faint">—</span>}</dd>
		</div>
	)
}

export function formatDate(value: string | null | undefined): string {
	if (!value) return '—'
	const d = new Date(value)
	if (Number.isNaN(d.getTime())) return '—'
	return d.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' })
}
